import PropTypes from 'prop-types';
import moment from 'moment';
import { 
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

const SiteHistory = ({siteLiveDate, liveDaysInQ}) => {

  return (
    <div className="mb-6">
      <h3 className="text-[16px] font-semibold mb-2">Site History</h3>
      <Table
        sx={{
          borderCollapse: 'separate',
          borderRadius: '15px',
          border: '1px solid rgb(224, 224, 224)',
        }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow key="table-header">
            <TableCell align="left">
              <p className="font-bold">Activation Date</p>
            </TableCell>
            <TableCell align="right">
              <p className="font-bold">Total days of usage in quarter</p>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="left">{moment(siteLiveDate.toDate()).format("DD-MM-YYYY")}</TableCell>
            <TableCell align="right">{liveDaysInQ}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  )
}

export default SiteHistory;

SiteHistory.propTypes = {
  siteLiveDate: PropTypes.instanceOf(Date).isRequired,
  liveDaysInQ: PropTypes.number.isRequired,
};